import { create } from 'zustand'
import cartService from '../services/cartService'

const useCartStore = create((set) => ({
    cart: [],
    loading: false,
    error: null,

    fetchCart: () => {
        set({ loading: true, error: null })
        try {
            const { success, data, message } = cartService.getCart()

            if (success) {
                set((state) => ({ cart: data, loading: false }))
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    createCart: async (cartData) => {
        set({ loading: true, error: null })
        const { success, message } = await cartService.createCart(cartData)
        if (success) {
            set((state) => ({ cart: [...state.cart, cartData], loading: false }))
            return { success: true }
        } else {
            set({ error: message, loading: false })
            console.error('Create Cart Error:', message)
            return { success: false, message }
        }
    },

    updateCart: async (cartId, cartData) => {
        set({ loading: true, error: null })
        const { success, message } = await cartService.updateCart(cartId, cartData)
        if (success) {
            set((state) => ({ order: data, loading: false }))
            return { success: true }
        } else {
            set({ error: message, loading: false })
            console.error('Update Cart Error:', message)
            return { success: false, message }
        }
    },

    deleteCart: async (cartId) => {
        set({ loading: true, error: null })
        try {
            const { success, message } = await cartService.deleteCart(cartId)
            if (success) {
                set((state) => ({
                    cart: state.cart.filter((order) => order.id !== cartId),
                    loading: false,
                }))
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    clearState: () => {
        set({ cart: [], loading: false, error: null })
    },
}))

export default useCartStore
